module.exports = __webpack_public_path__ + "img/Giordano Patrimoine_ Accueil en haut.135a6f26.jpg";